import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import {
  Button,
  Form,
  Input,
  notification,
  Col,
  Row,
  Select,
  Card,
  Tooltip,
} from "antd";

import { DeleteOutlined, SettingOutlined } from "@ant-design/icons";

import { getAuthuser } from "../../stored/mydata";

import apiGetBticinoInHome from "../../api/deviceRoomP/getBticinoInHome";
import apiGetDeviceInRoom from "../../api/deviceRoomP/getDeviceInRoom";
import apiGetRoomInHouse from "../../api/deviceRoomP/getRoomInHome";

import apiGetProject from "../../api/deviceRoomP/getProject";
import apiGetHouse from "../../api/deviceRoomP/getHouse";
import apiGetDvice from "../../api/deviceRoomP/getDevice";
import apiGetDviceName from "../../api/deviceRoomP/getDviceName";
import apiGetModel from "../../api/deviceRoomP/getModel";
import apiGetType from "../../api/deviceRoomP/getType";

import apiPostDevice from "../../api/deviceRoomP/postDevice";
import apiDeleteDevice from "../../api/deviceRoomP/deleteDevice";
// import apiPostDevice from "../../api/deviceRoom/postDevice";
// import apiDeleteDevice from "../../api/deviceRoom/deleteDevice";

// import ModalDeleteDevice from "./modalDeleteDevice";
import ModalDeleteDevice from "./modalDeleteDevice";
import ModalEditDevice from "./modalEditDevice";
import TableDevice from "./tableDevice";

const modelDefault = [
  {
    name: "bticino",
    type: ["lights", "dim", "curtains", "contact", "pir"],
  },
  {
    name: "obotrons",
    type: ["iaq", "emu"],
  },
  {
    name: "cassette",
    type: ["ac"],
  },
  {
    name: "cassette2",
    type: ["ac"],
  },
  {
    name: "allinone",
    type: ["ac"],
  },
  {
    name: "wulian",
    type: ["lights", "dim", "curtains", "contact", "pir", "curtain_tempering"],
  },
  {
    name: "schneider",
    type: ["lights", "dim", "curtains", "contact", "pir"],
  },
];

export default function AddDevice(props) {
  const authUser = useSelector(getAuthuser);
  const [formData] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();

  const [house, setHouse] = useState({
    house_number: "",
    room_code: "",
    unit_number: "",
  });
  const [room, setRoom] = useState({
    room_id: "",
    room_name: "",
  });

  // const [rooms, setRooms] = useState([]);
  const [device, setDevice] = useState([]);
  const [deviceName, setDeviceName] = useState([]);

  const [isModalDelete, setIsModalDelete] = useState(false);
  const [isModalEdit, setIsModalEdit] = useState(false);
  const [deviceEdit, setDeviceEdit] = useState({});
  const [deviceDelete, setDeviceDelete] = useState({});
  const [bticinoAll, setBticinoAll] = useState([]);

  const [roomCombinedDevice, setRoomCombinedDevice] = useState([]);
  const [deviceInRoom, setDeviceInRoom] = useState([]);
  const [typeAll, setTypeAll] = useState([]);
  const [deviceInHouse, setDeviceInHouse] = useState([]);

  const [chooseType, setChooseType] = useState(false);

  const [showForm, setShowForm] = useState(false);

  const [optionBticino, setOptionBticino] = useState([]);
  const [optionDevice, setOptionDevice] = useState([]);
  const [optionDeviceName, setOptionDeviceName] = useState([]);
  const [optionModel, setOptionModel] = useState([]);
  const [optionType, setOptionType] = useState([]);

  const [optionProject, setOptionProject] = useState([]);
  const [optionHouse, setOptionHouse] = useState([]);
  const [optionRooms, setOptionRooms] = useState([]);

  const getProject = async () => {
    try {
      const projectPromise = new Promise((resolve, reject) => {
        apiGetProject(authUser, (err, res) => {
          if (err) {
            reject(err);
          } else {
            resolve(res);
          }
        });
      });

      const [projectRes] = await Promise.all([projectPromise]);

      // houseRes
      if (projectRes["data"]) {
        var dataProject = [];
        projectRes["data"].map((e, i) => {
          dataProject.push({ ...e, value: e.id, label: e.name });
        });
        setOptionProject(dataProject);
      } else {
        props.showMessage(false, { description: "ดึงข้อมูล project ไม่ได้" });
      }
      // houseRes
    } catch (error) {
      console.log(error);
    }
  };

  const getData = async () => {
    try {
      // const housePromise = new Promise((resolve, reject) => {
      //   apiGetHouse(authUser, 3, (err, res) => {
      //     if (err) {
      //       reject(err);
      //     } else {
      //       resolve(res);
      //     }
      //   });
      // });
      const devicePromise = new Promise((resolve, reject) => {
        apiGetDvice(authUser, (err, res) => {
          if (err) {
            reject(err);
          } else {
            resolve(res);
          }
        });
      });
      const deviceNamePromise = new Promise((resolve, reject) => {
        apiGetDviceName(authUser, (err, res) => {
          if (err) {
            reject(err);
          } else {
            resolve(res);
          }
        });
      });
      const deviceModelPromise = new Promise((resolve, reject) => {
        apiGetModel(authUser, (err, res) => {
          if (err) {
            reject(err);
          } else {
            resolve(res);
          }
        });
      });
      const deviceTypePromise = new Promise((resolve, reject) => {
        apiGetType(authUser, (err, res) => {
          if (err) {
            reject(err);
          } else {
            resolve(res);
          }
        });
      });

      const [
        // houseRes,
        DeviceRes,
        DeviceNameRes,
        DeviceModelRes,
        DeviceTypeRes,
      ] = await Promise.all([
        // housePromise,
        devicePromise,
        deviceNamePromise,
        deviceModelPromise,
        deviceTypePromise,
      ]);

      // houseRes
      // if (houseRes["data"]) {
      //   var dataHouse = [];
      //   houseRes["data"].map((e, i) => {
      //     dataHouse.push({ ...e, value: e.id, label: e.house_number });
      //   });
      //   setOptionHouse(dataHouse);
      // } else {
      //   props.showMessage(false, { description: "ดึงข้อมูล House ไม่ได้" });
      // }
      // houseRes

      // DeviceRes
      if (DeviceRes["data"]) {
        var labelDevice = [];
        DeviceRes["data"].map((e) =>
          labelDevice.push({ ...e, label: e.name, value: e.id }),
        );
        setOptionDevice(labelDevice);
      }
      // DeviceRes

      // DeviceNameRes
      if (DeviceNameRes["data"]) {
        var labelDeviceName = [];
        DeviceNameRes["data"].map((e) =>
          labelDeviceName.push({ ...e, label: e.name, value: e.id }),
        );
        setOptionDeviceName(labelDeviceName);
      }
      // DeviceNameRes

      // modelRes
      if (DeviceModelRes["data"]) {
        var labelModel = [];
        DeviceModelRes["data"].map((e) =>
          labelModel.push({ ...e, label: e.name, value: e.id }),
        );
        setOptionModel(labelModel);
      }
      // modelRes

      //typeRes
      if (DeviceTypeRes["data"]) {
        var labelType = [];
        DeviceTypeRes["data"].map((e) =>
          labelType.push({ ...e, label: e.name, value: e.id }),
        );
        setTypeAll(labelType);
      }
      //typeRes
    } catch (error) {
      console.log(error);
    }
  };

  const getDataInHouse = async (value) => {
    try {
      const bticinoPromise = new Promise((resolve, reject) => {
        apiGetBticinoInHome(authUser, value.replace("/", "-"), (err, res) => {
          if (err) {
            reject(err);
          } else {
            resolve(res);
          }
        });
      });

      const devicehousePromise = new Promise((resolve, reject) => {
        apiGetDeviceInRoom(authUser, value, (err, res) => {
          if (err) {
            reject(err);
          } else {
            resolve(res);
          }
        });
      });

      const roomhousePromise = new Promise((resolve, reject) => {
        apiGetRoomInHouse(authUser, value, (err, res) => {
          if (err) {
            reject(err);
          } else {
            resolve(res);
          }
        });
      });

      const [bticinoRes, devicehouseRes, roomhouseRes] = await Promise.all([
        bticinoPromise,
        devicehousePromise,
        roomhousePromise,
      ]);

      // roomhouseRes
      if (roomhouseRes["data"]) {
        var dataRoom = [];
        roomhouseRes["data"].map((e) =>
          dataRoom.push({ ...e, value: e.id, label: e.room_name }),
        );

        setOptionRooms(dataRoom);
      }
      // roomhouseRes

      // devicehouseRes
      var combinedRooms = [];
      if (devicehouseRes["data"] && roomhouseRes["data"]) {
        for (let i = 0; i < roomhouseRes["data"].length; i++) {
          var combinedDevice = devicehouseRes["data"].filter(
            (e) => roomhouseRes["data"][i].room_name === e.room_name,
          );

          combinedRooms.push({
            ...roomhouseRes["data"][i],
            devices: combinedDevice,
          });
        }

        setRoomCombinedDevice(combinedRooms);
        setDeviceInHouse(devicehouseRes["data"]);
      }
      // devicehouseRes

      // bticinoRes
      if (bticinoRes["data"]) {
        // console.log(bticinoRes["data"]);

        var labelBticino = [];
        bticinoRes["data"].map((e) =>
          labelBticino.push({
            ...e,
            label: `${e.modules_name} | ${e.modules_type} ${e.room_name}`,
            value: `${e.home_id}-${e.modules_name}`,
          }),
        );

        setBticinoAll(labelBticino);

        const matchedDeviceBticino = labelBticino.filter(
          (h) =>
            !devicehouseRes["data"].some(
              (d) => d.device_id_name === h.modules_name,
            ),
        );

        setOptionBticino(matchedDeviceBticino);
      }
      // bticinoRes
    } catch (error) {
      console.log(error);
    }
  };

  const columnsDevice = [
    {
      title: "ID",
      dataIndex: "id",
      width: "6%",
      sorter: (a, b) => a.id - b.id,
      render: (_, record) => <div>{record.id}</div>,
    },
    {
      title: "เลขที่บ้าน",
      dataIndex: "house_number",
      width: "10%",
      ellipsis: {
        showTitle: false,
      },
      render: (_, record) => (
        <Tooltip placement="topLeft" title={record.house_number}>
          <div>{record.house_number}</div>
        </Tooltip>
      ),
    },
    {
      title: "ชื่อห้อง",
      dataIndex: "room_name",
      width: "40%",
      ellipsis: {
        showTitle: false,
      },
      render: (_, record) => (
        <Tooltip placement="topLeft" title={record.room_name}>
          <div>{record.room_name}</div>
        </Tooltip>
      ),
    },
    {
      title: "อุปกรณ์และชื่อ",
      dataIndex: "device_id_name",
      width: "10%",
      ellipsis: {
        showTitle: false,
      },
      render: (_, record) => (
        <Tooltip placement="topLeft" title={record.device_id_name}>
          <div>{record.device_id_name}</div>
        </Tooltip>
      ),
    },
    {
      title: "ชื่ออุปกรณ์",
      dataIndex: "device_name",
      width: "10%",
      ellipsis: {
        showTitle: false,
      },
      render: (_, record) => (
        <Tooltip placement="topLeft" title={record.device_name}>
          <div>{record.device_name}</div>
        </Tooltip>
      ),
    },
    {
      title: "แบบอย่าง",
      dataIndex: "device_model",
      width: "10%",
      ellipsis: {
        showTitle: false,
      },
      render: (_, record) => (
        <Tooltip placement="topLeft" title={record.device_model}>
          <div>{record.device_model}</div>
        </Tooltip>
      ),
    },
    {
      title: "ประเภทอุปกรณ์",
      dataIndex: "device_type",
      width: "10%",
      ellipsis: {
        showTitle: false,
      },
      render: (_, record) => (
        <Tooltip placement="topLeft" title={record.device_type}>
          <div>{record.device_type}</div>
        </Tooltip>
      ),
    },
    {
      title: "แก้ไข",
      // dataIndex: "device_type",
      width: "10%",
      ellipsis: {
        showTitle: false,
      },
      render: (_, record) => (
        <div>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              actionEditDevice(record);
            }}
          >
            <SettingOutlined />
          </div>
        </div>
      ),
    },
    {
      title: "ลบ",
      // dataIndex: "device_type",
      width: "10%",
      ellipsis: {
        showTitle: false,
      },
      // render: (_, record) => <div>{record.device_type}</div>,
      render: (_, record) => (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            actionDeleteDevice(record);
          }}
        >
          <DeleteOutlined />
        </div>
      ),
    },
  ];

  const onChangeProject = async (value) => {
    const housePromise = new Promise((resolve, reject) => {
      apiGetHouse(authUser, value["id"], (err, res) => {
        if (err) {
          reject(err);
        } else {
          resolve(res);
        }
      });
    });

    const [houseRes] = await Promise.all([housePromise]);

    // houseRes
    if (houseRes["data"]) {
      var dataHouse = [];
      houseRes["data"].map((e, i) => {
        dataHouse.push({ ...e, value: e.id, label: e.house_number });
      });
      setOptionHouse(dataHouse);
    } else {
      props.showMessage(false, { description: "ดึงข้อมูล House ไม่ได้" });
    }
    // houseRes
  };

  const onChangeHouse = (value) => {
    setHouse(value);
    getDataInHouse(value["house_number"]);
  };

  const onChangeRoom = (value) => {
    setRoom(value);

    var deviceInroom = roomCombinedDevice.filter(
      (e) => value.room_id === e.room_id,
    );

    setDeviceInRoom(deviceInroom[0]["devices"]);
  };

  const onChangeModel = (value) => {
    var optType = [];
    const match = modelDefault.find((m) => m.name === value.name);

    if (match) {
      optType.push(
        ...match.type
          .map((t) => {
            const found = typeAll.find((e) => e.name === t);
            return found ? { ...found, model: match["name"] } : null;
          })
          .filter(Boolean), // กัน null/undefined
      );
    }
    setOptionType(optType);

    actionBD();
  };

  const actionBD = () => {
    const matchedDeviceBticino = bticinoAll.filter(
      (h) => !deviceInHouse.some((d) => d.device_id_name === h.modules_name),
    );

    setOptionBticino(matchedDeviceBticino);
  };

  const onChangType = (value) => {
    if (
      value["name"] === "lights" ||
      value["name"] === "dim" ||
      value["name"] === "curtains" ||
      value["name"] === "contact" ||
      value["name"] === "pir"
    ) {
      if (value["model"] === "bticino") {
        setChooseType(true);
      } else {
        setChooseType(false);
      }
    } else {
      setChooseType(false);
    }
  };

  const openForm = () => {
    setShowForm(!showForm);
  };

  const onFinish = (value) => {
    var data = {
      room_id: room["id"].toString(),
      device_model: value["device_model"].toString(),
      device_type: value["device_type"].toString(),
      mac_id: value["mac_id"].toString(),
      device_id: value["device_id"].toString(),
      device_name: value["device_name"].toString(),
    };

    var checkBticino =
      optionBticino.find((e) => e.value === value["mac_id"])?.home_id || null;

    if (checkBticino) {
      data["mac_id"] = checkBticino;
    }

    apiPostDevice(authUser, data, (err, res) => {
      // console.log(res.status);

      if (!err && res.statusCode === 201) {
        formData.resetFields();
        setShowForm(false);

        resetTable(house["house_number"]);

        api["success"]({
          message: "success",
          description: res.Status,
        });
      } else {
        api["error"]({
          message: "error",
          description: "Error",
        });
      }
    });
  };

  // resetTable
  const resetTable = async (value) => {
    try {
      const bticinoPromise = new Promise((resolve, reject) => {
        apiGetBticinoInHome(authUser, value.replace("/", "-"), (err, res) => {
          if (err) {
            reject(err);
          } else {
            resolve(res);
          }
        });
      });

      const devicehousePromise = new Promise((resolve, reject) => {
        apiGetDeviceInRoom(authUser, value, (err, res) => {
          if (err) {
            reject(err);
          } else {
            resolve(res);
          }
        });
      });

      const roomhousePromise = new Promise((resolve, reject) => {
        apiGetRoomInHouse(authUser, value, (err, res) => {
          if (err) {
            reject(err);
          } else {
            resolve(res);
          }
        });
      });

      const [bticinoRes, devicehouseRes, roomhouseRes] = await Promise.all([
        bticinoPromise,
        devicehousePromise,
        roomhousePromise,
      ]);

      // bticinoRes
      if (bticinoRes["data"]) {
        var labelBticino = [];
        bticinoRes["data"].map((e) =>
          labelBticino.push({
            ...e,
            label: `${e.modules_name} | ${e.modules_type} ${e.room_name}`,
            value: `${e.home_id}-${e.modules_name}`,
          }),
        );

        setBticinoAll(labelBticino);

        const matchedDeviceBticino = labelBticino.filter(
          (h) =>
            !devicehouseRes["data"].some(
              (d) => d.device_id_name === h.modules_name,
            ),
        );

        console.log(matchedDeviceBticino);

        setOptionBticino(matchedDeviceBticino);
      }
      // bticinoRes

      // roomhouseRes
      if (roomhouseRes["data"]) {
        var dataRoom = [];
        roomhouseRes["data"].map((e) =>
          dataRoom.push({ ...e, value: e.id, label: e.room_name }),
        );
        setOptionRooms(dataRoom);
      }
      // roomhouseRes

      // devicehouseRes
      var combinedRooms = [];
      if (devicehouseRes["data"] && roomhouseRes["data"]) {
        for (let i = 0; i < roomhouseRes["data"].length; i++) {
          var combinedDevice = devicehouseRes["data"].filter(
            (e) => roomhouseRes["data"][i].room_name === e.room_name,
          );

          combinedRooms.push({
            ...roomhouseRes["data"][i],
            devices: combinedDevice,
          });
        }

        setRoomCombinedDevice(combinedRooms);
        setDeviceInHouse(devicehouseRes["data"]);
      }
      // devicehouseRes

      // setTable
      var deviceInroom = combinedRooms.filter(
        (e) => room.room_id === e.room_id,
      );

      setDeviceInRoom(deviceInroom[0]["devices"]);
      // setTable
    } catch (error) {
      console.log(error);
    }
  };
  // resetTable

  // EditDevice
  const actionEditDevice = (value) => {
    setDeviceEdit(value);
    setIsModalEdit(true);
  };
  const actionEdit = (status, value) => {
    if (status) {
      resetTable(house["house_number"]);
      setIsModalEdit(false);

      api["success"]({
        message: "success",
        description: value,
      });
    } else {
      api["error"]({
        message: "error",
        description: "Error",
      });
    }
  };
  // EditDevice

  // DeleteDevice
  const actionDeleteDevice = (value) => {
    setDeviceDelete(value);
    setIsModalDelete(true);
  };
  const actionDelete = () => {
    // console.log(deviceDelete);

    // var dataDelete = {
    //   id: deviceDelete["id"].toString(),
    //   room_id: deviceDelete["room_id"].toString(),
    //   mac_id: deviceDelete["macid_id"].toString(),
    //   device_id: deviceDelete["device_id"].toString(),
    //   device_name: deviceDelete["device_name_id"].toString(),
    //   device_model: deviceDelete["device_model_id"].toString(),
    //   device_typ: deviceDelete["device_type_id"].toString(),
    // };

    apiDeleteDevice(authUser, deviceDelete["id"], (err, res) => {
      if (!err && res.message === "Deleted") {
        formData.resetFields();

        resetTable(house["house_number"]);
        setIsModalDelete(false);

        api["success"]({
          message: "success",
          description: res.Status,
        });
      } else {
        api["error"]({
          message: "error",
          description: "Error",
        });
      }
    });
  };
  // DeleteDevice

  useEffect(() => {
    getProject();
    getData();
  }, []);

  return (
    <div>
      {contextHolder}
      <Card>
        <Row>
          <Col span={12}>
            <div>
              <div>กรุณาเลือกโปรเจค</div>
              <div>
                <Select
                  showSearch
                  style={{
                    width: "100%",
                  }}
                  placeholder="Process"
                  size="large"
                  options={optionProject}
                  onChange={(value, option) => {
                    onChangeProject(option);
                  }}
                />
              </div>
            </div>
          </Col>
          <Col span={12}></Col>
        </Row>
        <Row>
          <Col span={12}>
            <div>
              <div>กรุณาเลือกบ้าน</div>
              <div>
                <Select
                  showSearch
                  optionFilterProp="label"
                  style={{
                    width: "100%",
                  }}
                  placeholder="Process"
                  size="large"
                  options={optionHouse}
                  onChange={(value, option) => {
                    onChangeHouse(option);
                  }}
                />
              </div>
            </div>
          </Col>
          <Col span={12}>
            <div style={styles.showData}>
              <div>unit_number : {house["unit_number"]}</div>
              <div>room_code : {house["room_code"]}</div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <div>
              <div>กรุณาเลือกห้อง</div>
              <div>
                <Select
                  showSearch
                  optionFilterProp="label"
                  style={{
                    width: "100%",
                  }}
                  placeholder="Process"
                  size="large"
                  options={optionRooms}
                  onChange={(value, option) => {
                    onChangeRoom(option);
                  }}
                />
              </div>
            </div>
          </Col>
          <Col span={12}>
            <div style={styles.showData}>
              <div>room_id : {room["room_id"]}</div>
              <div>room_name : {room["room_name"]}</div>
            </div>
          </Col>
        </Row>
        <div>
          <Button onClick={openForm}>เพิ่ม Device</Button>
        </div>
        <Row>
          <Col span={12} style={{ margin: "20px 0 0 15px" }}>
            {showForm && room["room_id"] ? (
              <>
                <Form
                  form={formData}
                  onFinish={onFinish}
                  initialValues={{
                    device_model: "",
                    device_type: "",
                    mac_id: "",
                    device_id: "",
                    device_name: "",
                  }}
                >
                  <Form.Item
                    label="Model :"
                    name="device_model"
                    labelCol={{ flex: "100px" }}
                  >
                    <Select
                      showSearch
                      style={{
                        width: "100%",
                      }}
                      optionFilterProp="label"
                      options={optionModel}
                      onChange={(value, option) => {
                        onChangeModel(option);
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Type :"
                    name="device_type"
                    labelCol={{ flex: "100px" }}
                  >
                    <Select
                      showSearch
                      style={{
                        width: "100%",
                      }}
                      optionFilterProp="label"
                      options={optionType}
                      onChange={(value, option) => {
                        onChangType(option);
                      }}
                      // onChange={onChangType}
                    />
                  </Form.Item>

                  {chooseType ? (
                    <Form.Item
                      label="Bticino:"
                      name="mac_id"
                      labelCol={{ flex: "100px" }}
                    >
                      <Select
                        showSearch
                        style={{
                          width: "100%",
                        }}
                        optionFilterProp="label"
                        options={optionBticino}
                      />
                    </Form.Item>
                  ) : (
                    <>
                      <Form.Item label="Mac Address" name="mac_id">
                        <Input placeholder="mac address" size="large" />
                      </Form.Item>
                    </>
                  )}

                  <Form.Item
                    label="Device Id :"
                    name="device_id"
                    labelCol={{ flex: "100px" }}
                  >
                    <Select
                      showSearch
                      style={{
                        width: "100%",
                      }}
                      optionFilterProp="label"
                      options={optionDevice}
                    />
                  </Form.Item>
                  <Form.Item
                    label="DeviceName :"
                    name="device_name"
                    labelCol={{ flex: "100px" }}
                  >
                    <Select
                      showSearch
                      style={{
                        width: "100%",
                      }}
                      optionFilterProp="label"
                      options={optionDeviceName}
                    />
                  </Form.Item>
                  <Button type="primary" htmlType="submit">
                    Submit
                  </Button>
                </Form>
              </>
            ) : null}
          </Col>
          <Col span={12}></Col>
        </Row>
        <Row>
          <Col span={24}>Device ภายในห้อง</Col>
          {deviceInRoom.length ? (
            <>
              <TableDevice columns={columnsDevice} dataMeeting={deviceInRoom} />
            </>
          ) : (
            <>ไม่มีอุปกรณ์</>
          )}
          <Col span={24}></Col>
        </Row>
      </Card>

      <ModalDeleteDevice
        closeModal={() => {
          setIsModalDelete(false);
        }}
        open={isModalDelete}
        submitModal={actionDelete}
        data={deviceDelete}
      />

      <ModalEditDevice
        closeModal={() => {
          setIsModalEdit(false);
        }}
        submitModal={actionEdit}
        open={isModalEdit}
        dataDevice={deviceEdit}
        dataTypeAll={typeAll}
        bticino={bticinoAll}
        device={optionDevice}
        deviceName={optionDeviceName}
        deviceHouse={deviceInHouse}
        model={optionModel}
        authUser={authUser}
        // type={optionType}
      />
    </div>
  );
}

const styles = {
  showData: {
    margin: "18px 10px 5px 20px",
    color: "#4F4F4F",
    fontSize: "14px",
    fontWeight: "300",
    lineHeight: "22px",
  },
};
